import { useCommonPageContext } from '@atlassian/jira-servicedesk-common-page-context';
import { useRouter } from '@atlassian/react-resource-router';
import { EDIT_MODE, NEW_MODE, VIEW_MODE, COLLAPSED_MODE } from '../../common/constants';
import type { Mode } from '../../common/types';
import { getSlaPath } from '../../common/utils';

export type State = [
	{
		selectedMetricId: string | undefined | null;
		metricMode: Mode;
	},
	{
		updatePath: (metricId?: string | null, mode?: Mode) => void;
		replacePath: () => void;
	},
];

export const useMetricActions = (): State => {
	const [
		{
			match: {
				params,
				params: { id: selectedMetricId },
			},
		},
		{ push, replace },
	] = useRouter();

	const { baseUrl, projectKey } = useCommonPageContext();

	// @ts-expect-error - TS2322 - Type '"collapsed"' is not assignable to type 'Mode'.
	let metricMode: Mode = COLLAPSED_MODE;

	if (params['0'] === NEW_MODE) {
		metricMode = NEW_MODE;
	}

	if (selectedMetricId != null) {
		metricMode = VIEW_MODE;
	}

	if (params['1'] === EDIT_MODE) {
		metricMode = EDIT_MODE;
	}

	const updatePath = (metricId?: string | null, mode?: Mode) => {
		// @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
		const url = getSlaPath(baseUrl, projectKey, metricId, mode);
		push(url);
	};

	const replacePath = () => {
		// @ts-expect-error(TS2322 baseUrl, projectId or projectKey can be undefined, if usePageContext() returns null. Please handle undefined value in your code) - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
		const url = getSlaPath(baseUrl, projectKey);
		replace(url);
	};

	return [
		{ selectedMetricId, metricMode },
		{ updatePath, replacePath },
	];
};
